<template>
	<header id="header" class="header">
		<section class="headline">
			<div class="inner">
				<a
					class="logo"
					href="https://www.pixnet.net/"
					target="_blank"
					rel="noreferrer noopener"
				></a>
			</div>
		</section>
		<section class="kv">
			<div class="inner">
				<div
					class="bg"
					:style="heroStyle"
					@click="sendAnalytic('KV', 'Click', 'kv_click')"
				>
					<div class="bg-sub left">
						<a
							href="https://spa-reservation.chlitina.com.tw/pinkyouthkeeper2/"
							target="_blank"
							class="kv-btn"
							@click="sendAnalytic('CHLITINA', 'Click', `chlitina_click`)"
						>
							立即預約體驗
						</a>
						<a
							href="https://www.facebook.com/styleme.tw/posts/pfbid0258xVcFfdk6371ZYrp7JSoz9NLdUgryFbPNu5zG4nU66HbFh1ya473kUUf6DcPEwRl?__cft__[0]=AZUNtl18ofJqBWh4Ti_kK4vrOqxEdqfHoKEgXnCmXLWAebEShdAkPM2oaIfr1JR57xODXnLWCP6VXrO4C6AKHyZUPx0F3lFRO82yfNlWRPGoM-4h3M3wBfJQWc9xsOLyvNW5lURLnfE1Tz91q6pVo8bulAQVQtsUD3VKKZ8S93oV8f1rl9TFj51o1khLww97MX-VPrrVT-tFD43I7-YokcTK&__tn__=%2CO%2CP-R"
							target="_blank"
							class="kv-btn"
							style="display: none;"
							@click="sendAnalytic('Draw', 'Click', `Draw_click`)"
						>
							FB活動抽獎
						</a>
					</div>
				</div>
			</div>
		</section>
	</header>
</template>

<script setup>
import sendAnalytic from '@/common/sendAnalytic';
import heroDesktop from '@/assets/pc_kv1.jpg';
import heroMobile from '@/assets/mb_kv1.jpg';

const heroStyle = {
	'--hero-bg-pc': `url("${heroDesktop}")`,
	'--hero-bg-mobile': `url("${heroMobile}")`
};

</script>
